//var BASE_URL = "http://www.exadec.com/myfPublic";
var BASE_URL = "https://rrhh.myfdistribuciones.com.ar/public";
// var BASE_URL = "http://localhost:8888";
export default {
    BASE_URL: BASE_URL,
};



// WEBPACK FOOTER //
// ./src/Constants.js